import axios from 'axios';
import { BASE_API_URL } from '../constants';
import { xorDecrypt } from '../encrypt';

const getToken = () => {
    const encryptedToken = localStorage.getItem("ABAtoken");
    //console.log(xorDecrypt(encryptedToken)); // Debug log
    return xorDecrypt(encryptedToken); // Decrypt the token
  };

  export const fetchBtTargetAreaAddressed = async () => {
    const response = await axios.post(`${BASE_API_URL}/bt-target-area-addressed/getall`, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  };
  
  export const fetchBtNextSessionPlan = async () => {
    const response = await axios.post(`${BASE_API_URL}/bt-session-plans/getall`, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  };
  
  export const fetchBtSkillStrategiesApplied = async () => {
    const response = await axios.post(`${BASE_API_URL}/bt-skill-strategies-applied/getall`, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  };
  
  export const fetchBtBehaviorStrategiesApplied = async () => {
    const response = await axios.post(`${BASE_API_URL}/bt-behavior-strategies-applied/getall`, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  };
  
  export const fetchBtMalAdaptiveBehavior = async () => {
    const response = await axios.post(`${BASE_API_URL}/bt-maladaptive-behavior/getall`, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  };
  
  export const fetchBtReinforcer = async () => {
    const response = await axios.post(`${BASE_API_URL}/bt-reinforcer/getall`, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  };
  
  export const fetchBtClientMoodResponse = async () => {
    const response = await axios.post(`${BASE_API_URL}/bt-client-mood-response/getall`, {}, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
    });
    return response.data;
  };